// import React, { useEffect } from 'react'
// import { Route, Routes, Outlet } from 'react-router-dom'
// import Home from '../customer/pages/Home/Home'
// import Products from '../customer/pages/Products/Products'
// import ProductDetails from '../customer/pages/Products/ProductDetails/ProductDetails'
// import Cart from '../customer/pages/Cart/Cart'
// import Address from '../customer/pages/Checkout/AddressPage'
// import Profile from '../customer/pages/Account/Profile'
// import Footer from '../customer/components/Footer/Footer'
// import Navbar from '../customer/components/Navbar/Navbar'
// // import NotFound from '../customer/pages/NotFound/NotFound'
// import Auth from '../customer/pages/Auth/Auth'
// import { useAppDispatch, useAppSelector } from '../Redux Toolkit/Store'
// import { fetchUserCart } from '../Redux Toolkit/Customer/CartSlice'
// import PaymentSuccessHandler from '../customer/pages/Pyement/PaymentSuccessHandler'
// import Reviews from '../customer/pages/Review/Reviews'
// import WriteReviews from '../customer/pages/Review/WriteReview'
// import Wishlist from '../customer/pages/Wishlist/Wishlist'
// import { getWishlistByUserId } from '../Redux Toolkit/Customer/WishlistSlice'
// import SearchProducts from '../customer/pages/Search/SearchProducts'
// import PrivacyPolicy from '../customer/pages/PrivacyPolicy/PrivacyPolicy'
// import TermsAndConditions from '../customer/pages/TermAndCondition/TermAndCondition'
// import AboutUs from '../customer/pages/AboutUs/AboutUs'
// import ErrorPageLight from "../customer/pages/Error/ErrorPageLight";

// // Adding this snow effect
// import SnowfallOnly from "../components/Holiday/SnowfallOnly";



// // Layout that shows header + footer for normal pages
// const MainLayout = () => (
//   <>

//     {/* Added this for snow effect */}
//     <SnowfallOnly />
//     <Navbar />
//     <Outlet />
//     <Footer />
//   </>
// );

// const CustomerRoutes = () => {
//   const dispatch = useAppDispatch()
//   const { auth } = useAppSelector(store => store);

//   useEffect(() => {
//     dispatch(fetchUserCart(localStorage.getItem("jwt") || ""))
//     dispatch(getWishlistByUserId())
//   }, [auth.jwt, dispatch])

//   return (
//     <Routes>
//       {/* All standard pages use the layout (Navbar + Footer) */}
//       <Route element={<MainLayout />}>
//         <Route path='/' element={<Home />} />
//         <Route path='/products/:categoryId' element={<Products />} />
//         <Route path='/search-products' element={<SearchProducts />} />
//         <Route path='/reviews/:productId' element={<Reviews />} />
//         <Route path='/reviews/:productId/create' element={<WriteReviews />} />
//         <Route path='/product-details/:categoryId/:name/:productId' element={<ProductDetails />} />
//         <Route path='/cart' element={<Cart />} />
//         <Route path='/wishlist' element={<Wishlist />} />
//         <Route path='/checkout/address' element={<Address />} />
//         <Route path='/account/*' element={<Profile />} />
//         <Route path='/login' element={<Auth />} />
//         <Route path='/payment-success/:orderId' element={<PaymentSuccessHandler />} />
//         <Route path='/privacy-policy' element={<PrivacyPolicy />} />
//         <Route path='/term-and-condition' element={<TermsAndConditions />} />
//         <Route path='/aboutus' element={<AboutUs />} />
//       </Route>

//       {/* Catch-all error page WITHOUT header/footer */}
//       <Route path='*' element={<ErrorPageLight />} />
//     </Routes>
//   )
// }

// export default CustomerRoutes



import React, { useEffect } from 'react'
import { Route, Routes, Outlet } from 'react-router-dom'
import Home from '../customer/pages/Home/Home'
import Products from '../customer/pages/Products/Products'
import ProductDetails from '../customer/pages/Products/ProductDetails/ProductDetails'
import Cart from '../customer/pages/Cart/Cart'
import Address from '../customer/pages/Checkout/AddressPage'
import Profile from '../customer/pages/Account/Profile'
import Footer from '../customer/components/Footer/Footer'
import Navbar from '../customer/components/Navbar/Navbar'
// import NotFound from '../customer/pages/NotFound/NotFound'
import Auth from '../customer/pages/Auth/Auth'
import { useAppDispatch, useAppSelector } from '../Redux Toolkit/Store'
import { fetchUserCart } from '../Redux Toolkit/Customer/CartSlice'
import PaymentSuccessHandler from '../customer/pages/Pyement/PaymentSuccessHandler'
import Reviews from '../customer/pages/Review/Reviews'
import WriteReviews from '../customer/pages/Review/WriteReview'
import Wishlist from '../customer/pages/Wishlist/Wishlist'
import { getWishlistByUserId } from '../Redux Toolkit/Customer/WishlistSlice'
import SearchProducts from '../customer/pages/Search/SearchProducts'
import PrivacyPolicy from '../customer/pages/PrivacyPolicy/PrivacyPolicy'
import TermsAndConditions from '../customer/pages/TermAndCondition/TermAndCondition'
import AboutUs from '../customer/pages/AboutUs/AboutUs'
import ErrorPageLight from "../customer/pages/Error/ErrorPageLight";
import ContactUs from '../customer/pages/ContactUs/ContactUs'

// Adding this snow effect
import SnowfallOnly from "../components/Holiday/SnowfallOnly";


// Layout that shows header + footer for normal pages
const MainLayout = () => (
  <>
    {/* Added this for snow effect */}
    <SnowfallOnly />
    <Navbar />
    <Outlet />
    <Footer />
  </>
);

const LoginRequiredMessage = () => (
  <div className="min-h-[60vh] flex items-center justify-center px-4">
    <div className="text-center bg-white shadow-md rounded-xl p-6 max-w-md w-full">
      <h1 className="text-2xl font-semibold mb-3">
        Please Login
      </h1>

      <p className="text-gray-600">
        Login to access your account.
      </p>
    </div>
  </div>
);

const CustomerRoutes = () => {
  const dispatch = useAppDispatch()
  const { auth } = useAppSelector(store => store);

  const isLoggedIn = auth.jwt || localStorage.getItem("jwt");

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(fetchUserCart(localStorage.getItem("jwt") || ""))
      dispatch(getWishlistByUserId())
    }
  }, [auth.jwt, dispatch, isLoggedIn])

  return (
    <Routes>
      {/* All standard pages use the layout (Navbar + Footer) */}
      <Route element={<MainLayout />}>
        <Route path='/' element={<Home />} />
        <Route path='/products/:categoryId' element={<Products />} />
        <Route path='/search-products' element={<SearchProducts />} />
        <Route path='/reviews/:productId' element={<Reviews />} />
        <Route path='/reviews/:productId/create' element={<WriteReviews />} />
        <Route path='/product-details/:categoryId/:name/:productId' element={<ProductDetails />} />
        <Route path='/cart' element={<Cart />} />

        <Route
          path='/wishlist'
          element={
            isLoggedIn ? (
              <Wishlist />
            ) : (
              <LoginRequiredMessage />
            )
          }
        />

        <Route
          path='/checkout/address'
          element={
            isLoggedIn ? (
              <Address />
            ) : (
              <LoginRequiredMessage />
            )
          }
        />

        <Route
          path='/account/*'
          element={
            isLoggedIn ? (
              <Profile />
            ) : (
              <LoginRequiredMessage />
            )
          }
        />

        <Route path='/login' element={<Auth />} />
        <Route path='/payment-success/:orderId' element={<PaymentSuccessHandler />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/term-and-condition' element={<TermsAndConditions />} />
        <Route path='/aboutus' element={<AboutUs />} />
        <Route path='/contact' element={<ContactUs />} />
      </Route>

      {/* Catch-all error page WITHOUT header/footer */}
      <Route path='*' element={<ErrorPageLight />} />
    </Routes>
  )
}

export default CustomerRoutes